// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__4SMu4","active":"Navbar_active__4Ds2c","link":"Navbar_link__X8H3Z"};